// map of variant id to restock date, serialized in the section liquid
const restockDates = JSON.parse(document.querySelector("#productV18RestockJSON").textContent);

/************
 Swipers
 ************/

// thumbnails mobile
let productV18ThumbnailImages = new Swiper("#productV18ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV18ThumbnailsNext',
        prevEl: '#productV18ThumbnailsPrev',
    },
});

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideoV18(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

// main swiper
let productV18Images = new Swiper("#productV18Swiper", {
    navigation: {
        nextEl: '#productV18Swiper .productV18SwiperNext',
        prevEl: '#productV18Swiper .productV18SwiperPrev',
    },
    loop: true,
    thumbs: {
        swiper: productV18ThumbnailImages
    },
    on: {
        init: function () {
            playActiveSlideVideoV18(this);
        },
        slideChange: function () {
            playActiveSlideVideoV18(this);
        }
    }
});

// gallery desktop
document.querySelectorAll(".productV18GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV18Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV18Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV18Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV16(skipImage = false) {

    // check for an active color swatch
    activeVariant = product.variants.filter((variant) => {
        return variant.id === parseInt(document.querySelector(".productV18FormGroupFlexColor:checked").value)
    })[0];

    // find variant image by matching filename (media.id and featured_image.id differ in shopify's media model)
    if (!skipImage) {
        if (activeVariant.featured_image) {
            const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];
            const variantImage = Array.from(document.querySelectorAll(".productV18SwiperSlide")).find(slide => {
                const img = slide.querySelector("img");
                return img && img.src.split("/").pop().split("?")[0] === variantFilename;
            });
            if (variantImage) {
                productV18Images.slideTo(getElIndex(variantImage));
            }
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV18ATC").classList.remove("oos");
        document.querySelector("#productV18ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV18ATC").classList.add("oos");
        document.querySelector("#productV18ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // swap the ship date to the new variant's restock date
    updateShipping();
}

updateProductV16(true)

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV18FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV18FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV16();
    });
});


// variant dropdown support on change
document.querySelector("#productV18FormVariants")?.addEventListener("change", updateProductV16);


/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV18ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    const lineItem = {
        quantity: quantity,
        id: activeVariant.id,
    };

    // oversold variants with an upcoming restock carry the ship date through to the cart and checkout
    const restockDateObj = getRestockDate();
    if (restockDateObj) {
        lineItem.properties = {
            Ships: formatShipsDate(restockDateObj)
        };
    }
    formData.items.push(lineItem);


    // reverse form data
    formData.items.reverse();

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        // clear cart
        await clearCart();

        // add gift free gift
        // formData.items.push(
        //     {
        //         quantity: 1,
        //         id: 49838321369368
        //     }
        // )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        return;
    }

    // add productV18
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV18ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV18AddonCheckboxInput").checked) {
            document.querySelector("#productV18AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV18ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV18ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV18ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

// the sticky bar (sticky_bar setting) replaces the old fixed button
if (!document.querySelector("#productV18ATC").classList.contains("noSticky")) {
    stickyAtcObserver.observe(document.querySelector("#productV18Content"));
}

// event listeners for dropdown items
document.querySelectorAll(`.productV18DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});


/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV18ShippingRemainingTxt')) {
        document.querySelector('#productV18ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV18ShippingRemainingTxt')) {
        document.querySelector('#productV18ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}

// the active variant's restock date, or null when it has none or it has already passed
function getRestockDate() {
    const restockDate = restockDates[activeVariant.id];
    if (!restockDate) {
        return null;
    }

    // build the restock date from its parts so "2026-07-01" is treated as a local date, not UTC (which shifts the day)
    const [year, month, day] = restockDate.split("-").map(Number);
    const restockDateObj = new Date(year, month - 1, day);
    if (new Date() >= restockDateObj) {
        return null;
    }

    return restockDateObj;
}

// format a date like "Oct 8th" for the Ships line item property
function formatShipsDate(date) {
    const day = date.getDate();

    // 11th, 12th and 13th break the st/nd/rd pattern
    let suffix = "th";
    if (day % 100 < 11 || day % 100 > 13) {
        suffix = {1: "st", 2: "nd", 3: "rd"}[day % 10] || "th";
    }

    return `${date.toLocaleDateString("en-US", {month: "short"})} ${day}${suffix}`;
}

// show the restock date as the ship date until it passes, otherwise ships tomorrow
function updateShipping() {
    const shippingDateTxt = document.querySelector("#productV18ShippingDateTxt");

    const restockDateObj = getRestockDate();
    if (restockDateObj) {
        const restockText = restockDateObj.toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"});
        shippingDateTxt.innerHTML = `Ships <strong>${restockText}</strong>`;
        return;
    }

    // no upcoming restock, so fall back to the default ships-tomorrow text
    const date = new Date();
    date.setDate(date.getDate() + 1);
    const dateText = date.toLocaleDateString("en-US", {month: "short", day: "numeric"});
    shippingDateTxt.innerHTML = `Ships <strong>Tomorrow, ${dateText}</strong>`;
}

// initial paint for the default variant
updateShipping();


// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV18ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV18ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}

/**************
 Sticky Add to Cart bar (sticky_bar setting)
 Shows while the main Add to Cart is off screen (above or below); its button clicks the real one.
 ***************/

(function () {
    const bar = document.querySelector("#productV18Sticky");
    const atc = document.querySelector("#productV18ATC");
    if (!bar || !atc) {
        return;
    }
    const barATC = bar.querySelector("#productV18StickyATC");
    const compare = document.querySelector("#productV18PriceCompare");
    const actual = document.querySelector("#productV18PriceActual");

    // mirror the real button, prices and the selected colour into the bar
    function sync() {
        barATC.textContent = atc.textContent.trim();
        barATC.classList.toggle("oos", atc.classList.contains("oos"));
        barATC.classList.toggle("loading", atc.classList.contains("loading"));
        barATC.disabled = atc.disabled;
        bar.querySelector("#productV18StickyProductInfoPriceCompare").textContent = compare ? compare.textContent.trim() : "";
        bar.querySelector("#productV18StickyProductInfoPriceActual").textContent = actual ? actual.textContent.trim() : "";
        if (typeof activeVariant !== "undefined" && activeVariant) {
            if (activeVariant.featured_image && activeVariant.featured_image.src) {
                bar.querySelector("#productV18StickyProductImage").src = activeVariant.featured_image.src;
            }
            bar.querySelectorAll(".productV18StickyProductInfoSwatchesItem").forEach(function (el) {
                el.classList.toggle("active", parseInt(el.dataset.variantId) === activeVariant.id);
            });
        }
    }

    // colour swatches go through the page's own colour radios, so price, images and stock stay in one place
    bar.addEventListener("click", function (e) {
        const swatch = e.target.closest(".productV18StickyProductInfoSwatchesItem");
        if (!swatch) {
            return;
        }
        const radio = document.querySelector(`.productV18FormGroupFlexColor[value="${swatch.dataset.variantId}"]`);
        if (!radio) {
            return;
        }
        radio.checked = true;
        radio.dispatchEvent(new Event("change"));
    });

    barATC.addEventListener("click", function () {
        atc.click();
    });

    // keep the bar in step with the page
    new MutationObserver(sync).observe(atc, {attributes: true, childList: true, characterData: true, subtree: true});
    [compare, actual].forEach(function (el) {
        if (el) {
            new MutationObserver(sync).observe(el, {childList: true, characterData: true, subtree: true});
        }
    });
    document.addEventListener("change", function (e) {
        if (e.target.closest && e.target.closest(".productV18FormGroupFlexColor, #productV18FormVariants")) {
            sync();
        }
    });

    // show the bar whenever the main button is off screen; the 80px inset stops edge flicker
    function setVisible(atcInView) {
        bar.classList.toggle("active", !atcInView);
        bar.setAttribute("aria-hidden", atcInView ? "true" : "false");
    }
    new IntersectionObserver(function (entries) {
        setVisible(entries[0].isIntersecting);
    }, {threshold: 0, rootMargin: "0px 0px -80px 0px"}).observe(atc);

    // also check on load and scroll, for the first paint while images and CSS are still settling
    let checkQueued = false;
    function check() {
        checkQueued = false;
        const rect = atc.getBoundingClientRect();
        setVisible(rect.bottom > 0 && rect.top < window.innerHeight - 80);
    }
    function queueCheck() {
        if (!checkQueued) {
            checkQueued = true;
            window.requestAnimationFrame(check);
        }
    }
    window.addEventListener("scroll", queueCheck, {passive: true});
    window.addEventListener("resize", queueCheck);
    window.addEventListener("load", check);
    check();

    sync();
}());
